// ISO 3166-1 alpha-2 country codes for worldwide signup country selection.
// Localized names are resolved at runtime via Intl.DisplayNames.

export const GCC_COUNTRY_CODES = ['SA', 'AE', 'OM', 'KW', 'BH', 'QA'];

export const ALL_COUNTRY_CODES = [
  'AF','AL','DZ','AD','AO','AG','AR','AM','AU','AT','AZ','BS','BH','BD','BB','BY','BE','BZ','BJ','BT','BO','BA','BW',
  'BR','BN','BG','BF','BI','CV','KH','CM','CA','CF','TD','CL','CN','CO','KM','CG','CD','CR','CI','HR','CU','CY','CZ',
  'DK','DJ','DM','DO','EC','EG','SV','GQ','ER','EE','SZ','ET','FJ','FI','FR','GA','GM','GE','DE','GH','GR','GD','GT',
  'GN','GW','GY','HT','HN','HU','IS','IN','ID','IR','IQ','IE','IL','IT','JM','JP','JO','KZ','KE','KI','KP','KR','KW',
  'KG','LA','LV','LB','LS','LR','LY','LI','LT','LU','MG','MW','MY','MV','ML','MT','MH','MR','MU','MX','FM','MD','MC',
  'MN','ME','MA','MZ','MM','NA','NR','NP','NL','NZ','NI','NE','NG','MK','NO','OM','PK','PW','PS','PA','PG','PY','PE',
  'PH','PL','PT','QA','RO','RU','RW','KN','LC','VC','WS','SM','ST','SA','SN','RS','SC','SL','SG','SK','SI','SB','SO',
  'ZA','SS','ES','LK','SD','SR','SE','CH','SY','TW','TJ','TZ','TH','TL','TG','TO','TT','TN','TR','TM','TV','UG','UA',
  'AE','GB','US','UY','UZ','VU','VA','VE','VN','YE','ZM','ZW'
];

// Resolve a localized country name. Falls back to the code itself.
export const getCountryName = (code, language = 'en') => {
  if (!code) return '';
  try {
    const lang = language === 'ar' ? 'ar' : 'en';
    const dn = new Intl.DisplayNames([lang], { type: 'region' });
    return dn.of(code) || code;
  } catch {
    return code;
  }
};

// Build an alphabetically-sorted [{code, name}] list, optionally with GCC pinned to top.
export const getCountryOptions = (language = 'en', { gccFirst = false } = {}) => {
  const items = ALL_COUNTRY_CODES.map((code) => ({
    code,
    name: getCountryName(code, language),
  }));
  items.sort((a, b) => a.name.localeCompare(b.name, language === 'ar' ? 'ar' : 'en'));
  if (!gccFirst) return items;
  const isGcc = (c) => GCC_COUNTRY_CODES.includes(c);
  return [
    ...items.filter((i) => isGcc(i.code)),
    ...items.filter((i) => !isGcc(i.code)),
  ];
};

export const isGccCountry = (code) => GCC_COUNTRY_CODES.includes(code);
